import { AbilitySubject, every, not } from "@cdv/jazz-auth";
import { User } from "../../api";
import { isAdmin, isAppuser } from "../utils";

export default function defineUserAbility(can: AbilitySubject<User>): void {
  can("read", not(isAppuser));
  can(["update", "delete", "create"], isAdmin);
}
